const accessSettings = {

    USER_ROLE_LIST: {
        path: '/user-role-list'
    },

    ADD_USER_ROLE: {
        path: '/create-user-role'
    },

    UPDATE_USER_ROLE: {
        path: '/edit-user-role'
    },


    MODULE_LIST: {
        path: '/module-list'
    },

    ADD_MODULE: {
        path: '/create-module'
    },

    UPDATE_MODULE: {
        path: '/edit-module'
    },


    ACTION_LIST: {
        path: '/action-list'
    },

    ADD_ACTION: {
        path: '/create-action'
    },

    UPDATE_ACTION: {
        path: '/edit-action'
    },


    PERMISSION: {
        path: '/permission'
    },
}

export default accessSettings;